import classnames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { Node_Type } from "./../../ricos-types/index.js";
import { getLangDir } from "./../../wix-rich-content-common/index.js";
import { Card } from "../components/card.js";
import { ROOT } from "../data-hooks.js";
import { VERTICAL_EMBED_TYPE } from "../types.js";
import {
  generateVerticalEmbedClasses,
  generateVerticalEmbedStyles
} from "./vertical-embed-styles.js";
import classes from "./vertical-embed-viewer-scss.js";
const VerticalEmbedViewer = ({
  settings,
  componentData,
  helpers,
  nodeId
}) => {
  const { t, locale, tabIndex } = useContext(RicosContext);
  const isEditor = tabIndex === -1;
  const url = settings.changeBaseUrl ? settings.changeBaseUrl(componentData.url) : componentData.url;
  const onClick = () => helpers?.onViewerAction?.(VERTICAL_EMBED_TYPE, "Click", componentData.type, nodeId, {
    type: Node_Type.APP_EMBED,
    appEmbedData: componentData
  });
  const shouldHandleClick = !!helpers?.onViewerAction;
  const handleClick = (e) => {
    if (!shouldHandleClick) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick();
    if (url && !isEditor) {
      window.open(url, "_blank", "noreferrer");
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick(e);
    }
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames(
        classes.card,
        generateVerticalEmbedClasses(componentData, settings, classes)
      ),
      "data-hook": ROOT,
      "data-url": url,
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      style: generateVerticalEmbedStyles(componentData, settings),
      tabIndex: isEditor ? -1 : tabIndex,
      role: "button",
      "aria-label": componentData.name,
      title: componentData.name
    },
    /* @__PURE__ */ React.createElement(
      Card,
      {
        componentData,
        url,
        title: componentData.name,
        image: componentData?.hideImage ? void 0 : componentData.image,
        buttonText: componentData?.buttonStyles?.buttonText || t(
          {
            PRODUCT: "VerticalEmbed_Products_Button",
            EVENT: "VerticalEmbed_Events_Button",
            BOOKING: "VerticalEmbed_Bookings_Button"
          }[componentData.type]
        ),
        ribbonText: componentData.ribbonStyles?.ribbonText || t("VerticalEmbed_Ribbon"),
        direction: getLangDir(locale)
      }
    )
  );
};
export {
  VerticalEmbedViewer
};
//# sourceMappingURL=vertical-embed-viewer.js.map
